import React from 'react';
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const planningTabs = [
  {
    title: "Business",
    icon: <BusinessCenterIcon />,
  },
  {
    title: "CashFlow",
    icon: <CurrencyRupeeIcon />,
  },
];

const PlanningTabs = ({ activeBuisnessTab, setActiveBuisnessTab }) => {
  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      margin: '40px auto 20px auto',
      background: '#f1f5f9',
      padding: '4px',
      borderRadius: '12px',
      border: '1px solid rgba(226, 232, 240, 0.8)',
      gap: '2px',
    }}>
      {planningTabs.map((item, index) => {
        const isActive = activeBuisnessTab === item.title;
        return (
          <button
            key={index}
            onClick={() => setActiveBuisnessTab(item.title)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              padding: '10px 24px',
              borderRadius: '9px',
              border: 'none',
              background: isActive
                ? 'linear-gradient(135deg, #00807a 0%, #004d49 100%)'
                : 'transparent',
              color: isActive ? '#ffffff' : '#64748b',
              fontSize: '13px',
              fontWeight: isActive ? '700' : '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              letterSpacing: '0.03em',
              minWidth: '130px',
              height: '40px',
              whiteSpace: 'nowrap',
              boxShadow: isActive
                ? '0 2px 8px rgba(0, 128, 122, 0.3)'
                : 'none',
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = 'rgba(0, 128, 122, 0.08)';
                e.currentTarget.style.color = '#00807a';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#64748b';
              }
            }}
          >
            {React.cloneElement(item.icon, {
              style: {
                fontSize: '17px',
                color: isActive ? '#ffffff' : '#64748b',
                transition: 'color 0.2s ease',
              },
            })}
            <span style={{ textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.06em' }}>
              {item.title}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default PlanningTabs;